import { render, staticRenderFns } from "./DevicesReports.vue?vue&type=template&id=ef572f22"
import script from "./DevicesReports.vue?vue&type=script&lang=js"
export * from "./DevicesReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports